import Model from './Model'

export default class Brand extends Model {
  resource()
  {
    return 'brands'
  }

  toFilterOptions(models) {
    if (!Array.isArray(models)) return [];
    return models.map(model => ({
      value: String(model.id),
      label: (model.exponent?.name ? model.exponent?.name + ' - ' : '') +  model.name
    }));
  }
}